import { useQuery } from "@tanstack/react-query";
import ApiSink from "../api/sink";
import { ITag } from "../types/Tag";

const apiSink = new ApiSink();

export function useTags() {
  const query = useQuery({
    queryKey: ["tags"],
    queryFn: async ({ signal }) => {
      const response = await apiSink.getTags(signal);
      if (response.error) return [];
      // Tags API returns { data: { tags } } format
      return response.data?.tags || [];
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    tags: (query.data || []) as ITag[],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
